import { useNavigate } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import FilledButton from "../components/FilledButton";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
      <div className="text-center space-y-6 px-4">
        <div className="space-y-2">
          <h1 className="text-6xl sm:text-7xl font-bold text-slate-900">404</h1>
          <h2 className="text-2xl sm:text-3xl font-semibold text-slate-700">
            Page Not Found
          </h2>
          <p className="text-slate-600 text-sm sm:text-base max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="pt-4">
          <FilledButton
            text="Go to Dashboard"
            IconFirst={HomeIcon}
            iconFirstColor="white"
            btnClicked={() => navigate("/dashboard")}
            width="auto"
            padding="3"
          />
        </div>
      </div>
    </div>
  );
}
